
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
import { emitter, NotificationType } from "@/composables/emitter";
export default Vue.extend({
  data() {
    return {
      forms: [] as { _id: string, name: string}[],
      formId: "",
      thumbnailFile: undefined as any,
      themeName: "",
      category: "",
      priority: 1,
    };
  },
  computed: {
    validAddPrebuiltForm(): boolean {
      return this.themeName && this.formId && this.thumbnailFile && this.category ? true : false;
    },
  },
  methods: {
    async getAllForms() {
      try {
        const allForms = await FormsAndSurveyServices.getAllFormsForThemes({
          locationId: config.prebuiltFormLocation,
          limit: 50
        });
        this.forms = allForms.data.forms;
      } catch (error) {
        console.error(error);
      }
    },
    async addPrebuiltForm() {
      try {
        const bodyThemeData = new FormData();
        bodyThemeData.append("themeName", this.themeName);
        bodyThemeData.append("thumbnail", this.thumbnailFile);
        bodyThemeData.append("formId", this.formId);
        bodyThemeData.append("category", this.category);
        bodyThemeData.append("priority", this.priority.toString());
        const result = await FormsAndSurveyServices.createThemes(bodyThemeData);
        if (result.status === 201) {
          this.resetInput()
        }
      } catch (error: any) {
        console.error(error);
        const data = this.$refs.thumbnailUpload as HTMLInputElement;
        data.value  = '';
        emitter.$emit("notification", {
          title: "Add Failed",
          message: error.response?.data?.message || error,
          type: NotificationType.ERROR,
        });
      }
    },
    readThumbnailChange(e: any) {
      const element = <HTMLInputElement>e.target;
      if (!element.files) return;
      this.thumbnailFile = element.files[0];
    },
    resetInput(){
      this.themeName = "";
      this.formId = "";
      this.thumbnailFile = undefined;
      this.category = "";
      this.priority = 1;
      const data = this.$refs.thumbnailUpload as HTMLInputElement;
      data.value  = '';
    }
  },
  async mounted() {
    await this.getAllForms();
  },
});
